import { render, staticRenderFns } from "./dashboardMeterial.vue?vue&type=template&id=7064e594&scoped=true"
import script from "./dashboardMeterial.vue?vue&type=script&lang=js"
export * from "./dashboardMeterial.vue?vue&type=script&lang=js"
import style0 from "./dashboardMeterial.vue?vue&type=style&index=0&id=7064e594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064e594",
  null
  
)

export default component.exports